import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Snackbar, makeStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import { selectCurrentUser } from "../../redux/user/user.selector";
import { saveReport } from "../../redux/reports/report.actions";
import PhotoUploader from "../form-inputs/photo-upload.component";
import "./report.styles.scss";
import { Switch, TextField, Button } from "@material-ui/core";
import PdfUpload from "../form-inputs/pdf-upload";

const useStyles = makeStyles({
  pdfElement: {
    margin: "10px 0 20px 0",
  },
});

const ReportEditComponent = ({ currentReport, saveReport }) => {
  const classes = useStyles();
  const [report, setReport] = useState(currentReport);
  const [isPdfChanged, setPdfChanged] = useState(false);
  const [saved, setSaved] = useState(false);
  const handleChange = (event) => {
    const { checked, value, name } = event.target;
    name === "oeffentlich"
      ? setReport({ ...report, [name]: checked })
      : setReport({ ...report, [name]: value });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    saveReport(report, () => setSaved(true));
  };
  const handlePdf = ({ name, url }) => {
    setReport({ ...report, pdf: { name: name, url: url } });
    setPdfChanged(true);
  };
  useEffect(() => {
    isPdfChanged && saveReport(report, () => setSaved(true));
    setPdfChanged(false);
  }, [report.pdf, isPdfChanged, report, saveReport]); // Only re-run the effect if count changes
  return (
    <div className="reportEditComponent">
      <form onSubmit={handleSubmit}>
        <TextField
          name="titel"
          type="text"
          value={report.titel}
          onChange={handleChange}
          required
          label="Titel"
          inputProps={{ maxLength: 100 }}
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <TextField
          name="frage1"
          type="textarea"
          value={report.frage1}
          onChange={handleChange}
          label="Was haben wir gemacht?"
          inputProps={{ maxLength: 1000 }}
          multiline
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <TextField
          name="frage2"
          type="text"
          value={report.frage2}
          onChange={handleChange}
          label="Was ist daran für uns neu?"
          inputProps={{ maxLength: 1000 }}
          multiline
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <TextField
          name="frage3"
          type="text"
          value={report.frage3}
          onChange={handleChange}
          label="Gab es einen ähnlichen Versuch schon mal bei uns?"
          inputProps={{ maxLength: 1000 }}
          multiline
          fullWidth
          margin="normal"
          variant="outlined"
        />
        <TextField
          name="frage4"
          type="text"
          value={report.frage4}
          onChange={handleChange}
          label="Wie ist es gelaufen"
          inputProps={{ maxLength: 1000 }}
          multiline
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <TextField
          name="frage5"
          type="text"
          value={report.frage5}
          onChange={handleChange}
          label="Haben sich unsere Erwartungen erfüllt?"
          inputProps={{ maxLength: 1000 }}
          multiline
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <TextField
          name="frage6"
          type="text"
          value={report.frage6}
          onChange={handleChange}
          label="Was haben wir gelernt?"
          inputProps={{ maxLength: 1000 }}
          multiline
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <TextField
          name="kontakt"
          type="text"
          value={report.kontakt}
          onChange={handleChange}
          label="So bin ich erreichbar:"
          inputProps={{ maxLength: 100 }}
          multiline
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <TextField
          name="autor"
          type="text"
          value={report.autor}
          onChange={handleChange}
          label="Autor"
          inputProps={{ maxLength: 100 }}
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <Switch
          name="oeffentlich"
          checked={report.oeffentlich}
          onChange={handleChange}
        />
        Dieser Bericht darf im Dekanat veröffentlicht werden
        <div className="fotos">
          <PhotoUploader
            name="bild1"
            value={report.bild1}
            handleChange={handleChange}
          />
          <PhotoUploader
            name="bild2"
            value={report.bild2}
            handleChange={handleChange}
          />
        </div>
        <div className={classes.pdfElement}>
          <PdfUpload
            reportId={report.id}
            setter={handlePdf}
            pdf={report.pdf}
            label="PDF-Dokument"
          />
        </div>
        <Button variant="contained" type="submit">
          Speichern
        </Button>
        <Snackbar
          open={saved}
          autoHideDuration={6000}
          onClose={() => setSaved(false)}
        >
          <Alert severity="success">Gespeichert</Alert>
        </Snackbar>
      </form>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => ({
  saveReport: (report, callback) => dispatch(saveReport(report, callback)),
});

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportEditComponent);
